
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns65c32f454b6b7ac279465087abd1f155en from './en.yaml'
            i18n.addResourceBundle('en', '65c32f454b6b7ac279465087abd1f155', flattenObject(ns65c32f454b6b7ac279465087abd1f155en), true, true);
        
        export default '65c32f454b6b7ac279465087abd1f155';
    